import { fromPostgrest, guard, type Result } from '@/lib/result';
import { supabase } from '@/lib/supabase';

import { mapMessage, type Message } from '../model/message';

export const chatRepository = {
  async listForApplication(applicationId: string): Promise<Result<readonly Message[]>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('messages')
        .select('*')
        .eq('application_id', applicationId)
        .order('created_at', { ascending: true });
      if (error) throw fromPostgrest(error);
      return ((data ?? []) as unknown[]).map(mapMessage);
    });
  },

  async send(applicationId: string, senderId: string, body: string): Promise<Result<Message>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('messages')
        .insert({ application_id: applicationId, sender_id: senderId, body })
        .select('*')
        .single();
      if (error) throw fromPostgrest(error);
      return mapMessage(data as unknown);
    });
  },

  /** Subscribe to new messages for an application via Realtime. Returns unsubscribe. */
  subscribe(applicationId: string, onInsert: () => void): () => void {
    const channel = supabase
      .channel(`messages:${applicationId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `application_id=eq.${applicationId}`,
        },
        () => onInsert(),
      )
      .subscribe();
    return () => {
      void supabase.removeChannel(channel);
    };
  },
};
